import { About } from "./About";
import { Footer } from "./Footer";
import { Header } from "./Header";
import { Missing } from "./Missing";
import { Nav } from "./Nav";
import {Home} from "./Home";
import {NewPost} from "./NewPost";
import  {PostPage}  from "./PostPage";
import { Routes,Route,Link, useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import {format, set} from "date-fns";
import { EditPost } from "./EditPost"; 
import { useWindowSize } from "./hooks/useWindowSize";








function App() {
  const [posts, setPosts] = useState(() => {
  const savedPosts = localStorage.getItem('posts');
  return savedPosts ? JSON.parse(savedPosts) : [
    {
      id: 1,
      title: 'My First Post',
      datetime: 'July 01, 2025 11:17:36 AM',
      body: 'Made a video about Tesla Q1 results'
    },
    {
      id: 2,
      title: 'My second Post',
      datetime: 'July 01, 2025 11:17:36 AM',
      body: 'I attended a DeFi blockchain event'
    },
    {
      id: 3,
      title: 'My thirty Post',
      datetime: 'July 01, 2025 11:17:36 AM',
      body: 'Web3 global summit next week'
    },
    {
      id: 4,
      title: 'My four Post',
      datetime: 'July 01, 2025 11:17:36 AM',
      body: 'ETH will outperform BTC'
    }
  ];
});

useEffect(() => {
  localStorage.setItem('posts', JSON.stringify(posts));
}, [posts]);


  const [search,setSearch] =useState('')
  const [searchResults,setSearchResults] = useState([])
  const [postTitle,setPostTitle] = useState('')
  const [postBody,setPostBody] = useState('')
  const [editTitle,setEditTitle] = useState('')
  const [editBody,setEditBody] = useState('')
  const { width } = useWindowSize();
  
  const navigate = useNavigate()

  useEffect(() =>{
    const filteredResults = posts.filter((post) => ((post.body).toLowerCase()).includes(search.
      toLowerCase())
    || ((post.title).toLowerCase()).includes(search.toLowerCase()));

    setSearchResults(filteredResults.reverse())
  },[posts, search])


  const handleSubmit = (e) => {
    e.preventDefault();
    const id = posts.length ? posts[posts.length - 1].id + 1 : 1;
    const datetime = format(new Date(), 'MMMM dd, yyyy pp');
    const newPost = {id, title: postTitle, datetime,body:postBody};
    const allPosts = [...posts,newPost];
    setPosts(allPosts);
    setPostTitle('');
    setPostBody('');
    navigate('/')
  }

  const handleEdit = (id) => {
     const datetime = format(new Date(), 'MMMM dd, yyyy pp');
     const updatedPost = {id, title: editTitle, datetime,body:editBody};
     setPosts(posts.map(post => post.id===id ? {...updatedPost} : post));
    setEditTitle('');
    setEditBody('');
    navigate('/')
    
  }

  const handleDelete = (id) => {
    const postsList = posts.filter(post => post.id !== id )
    setPosts(postsList)
    navigate('/')
  }

   
  
 
  return (
    <div className="App">
      <Header title="Social  Media" width={width}/>
      <Nav
      search={search}
      setSearch={setSearch}/>
       <Routes>
      {/* Home page route */}
      <Route path="/" element={<Home posts={searchResults} />} />

      {/* Post-related routes */}
      <Route path="post">
        {/* New post page - /post */}
        <Route
          index
          element={
            <NewPost
              handleSubmit={handleSubmit}
              postTitle={postTitle}
              setPostTitle={setPostTitle}
              postBody={postBody}
              setPostBody={setPostBody}
            />
          }
        />

        {/* Single post page - /post/:id */}
        <Route
          path=":id"
          element={<PostPage posts={posts} handleDelete={handleDelete} />}
        />
      </Route>

          <Route
      path="edit/:id"
      element={
        <EditPost
          posts={posts}
          handleEdit={handleEdit}
          editTitle={editTitle}
          setEditTitle={setEditTitle}
          editBody={editBody}
          setEditBody={setEditBody}
        />
      }
    />


      {/* About page */}
      <Route path="about" element={<About />} />

      {/* 404 - Not found */}
      <Route path="*" element={<Missing />} />
    </Routes>
      <Footer/>
     
    </div>
  );
}

export default App;
